module.exports = __webpack_public_path__ + "static/media/ceo.placeholder.3523ffff.jpg";